import { useSnackbar } from "notistack";
import React, { ReactNode } from "react";
import { SimplePopupType } from "./data";

interface ISimplePopupContext {
  createSimplePopup(title: ReactNode, type: SimplePopupType): void;
}

const SimplePopupContext = React.createContext<ISimplePopupContext>(
  {} as ISimplePopupContext
);

export const useSimplePopups = () => {
  return React.useContext(SimplePopupContext);
};

interface IProps {
  children: React.ReactNode;
}

export const SimplePopupProvider = ({
  children,
}: IProps): React.ReactElement<IProps> => {
  const { enqueueSnackbar } = useSnackbar();

  const simplePopupContext: ISimplePopupContext = {
    createSimplePopup(title, type) {
      enqueueSnackbar(title, {
        variant: type,
      });
    },
  };

  return (
    <SimplePopupContext.Provider value={simplePopupContext}>
      {children}
    </SimplePopupContext.Provider>
  );
};

export default SimplePopupProvider;
